import { render, staticRenderFns } from "./NumberOfTrainingsToBeTaken.vue?vue&type=template&id=da12a692"
import script from "../../../scripts/partials/dashboard-charts/NumberOfTrainingsToBeTaken.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/dashboard-charts/NumberOfTrainingsToBeTaken.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports